/**
 * Haptic feedback — device only. A no-op on web (and whenever the player has
 * turned haptics off in Settings). The plugin is loaded lazily so the web bundle
 * never pulls it in.
 */
import { Capacitor } from '@capacitor/core';
import { Progress } from './progress';

function active(): boolean {
  return Capacitor.isNativePlatform() && Progress.hapticsEnabled();
}

async function impact(style: 'Light' | 'Medium' | 'Heavy') {
  if (!active()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle[style] });
  } catch { /* haptics unavailable — ignore */ }
}

async function notify(type: 'Success' | 'Warning' | 'Error') {
  if (!active()) return;
  try {
    const { Haptics, NotificationType } = await import('@capacitor/haptics');
    await Haptics.notification({ type: NotificationType[type] });
  } catch { /* ignore */ }
}

export const Buzz = {
  /** Light tick — UI taps. */
  tap() { void impact('Light'); },
  /** Medium thud — committing a breach. */
  breach() { void impact('Medium'); },
  /** Success pattern — a level cleared. */
  win() { void notify('Success'); },
  /** Heavy jolt — a run failed. */
  fail() { void impact('Heavy'); },
};
